import Api from "./Api";

export type ResponseType = "arraybuffer" | "blob" | "document" | "json" | "text" | "stream";
interface IDownloadReport {
  fileType: string;
  language: string;
  requestId: string;
}

class TestReportDownloadApi {
  constructor(private api: Api) {}

  public downloadReport({ fileType, language, requestId }: IDownloadReport) {
    const arraybuffer: ResponseType = "arraybuffer";
    const params = new URLSearchParams([
      ["fileType", fileType],
      ["language", language],
    ]);
    const config = {
      params,
      responseType: arraybuffer,
    };
    return this.api.get(`/test-request/v2/report/${requestId}`, config);
  }
}

export default TestReportDownloadApi;
